export default __webpack_public_path__ + "static/media/14.bfaccc5a.png";